import angular from 'angular';
import dateFormatService from '../../../shared/services/DateFormatService';

angular.module('commonServices').filter('formatDate', [
  function() {
    return dateFormatService.formatDate;
  },
]);

angular.module('commonServices').filter('formatDateWithTime', [
  function() {
    return dateFormatService.formatDateWithTime;
  },
]);

angular.module('commonServices').filter('formatDayMonth', [
  function() {
    return dateFormatService.formatDayMonth;
  },
]);

angular.module('commonServices').filter('formatDateLong', [
  function() {
    return dateFormatService.formatDateLong;
  },
]);

angular.module('commonServices').filter('formatDateInFull', [
  function() {
    return dateFormatService.formatDateInFull;
  },
]);
angular.module('commonServices').filter('correctFormatForConfiguration', [
  '$filter',
  function($filter) {
    return function(format) {
      const translated = $filter('translate')(format);
      return dateFormatService.correctFormatForConfiguration(translated);
    };
  },
]);
